import self from '../img/self.png';
import self2 from '../img/self2.png';
import self3 from '../img/self3.png';
import freshbot from "../img/freshbot.png"
import speechtotext from "../img/speechtotext.png"
import cubix from "../img/cubix.png"
import onshapeCubix from "../img/onshapeCubix.png"
import overbooked from "../img/overbooked.png"
import realpay from "../img/realpay.png"
import sitespeedtest from "../img/sitespeedtest.png"
import dividendcalculator from "../img/dividendcalculator.png"
import pulse from "../img/pulse.png"
import BlackJack from "../img/BlackJack.jpg"
import ScratchOff from "../img/ScratchOff.png"
import PositioningDesk from "../img/positioningdesk.png"
import { colors } from '../colors/mainGradient';

export const info = {
  firstName: 'Matthew',
  lastName: 'Zou',
  initials: 'MZ', // the example uses first and last, but feel free to use three or more if you like.
  position: 'Software Engineer',
  selfPortrait: self2, // don't change this unless you want to name your self-portrait in the "img" folder something else!
  gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
  baseColor: colors[0],
  miniBio: [ // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
    {
      emoji: '🌎',
      text: 'Based in Maryland, USA',
    },
    {
      emoji: '💻',
      text: 'Software Engineer at NAVAIR',
    },
    {
      emoji: '📧',
      text: 'mzou1212@gmail.com',
    },
  ],
  socials: [
    {
      // link: 'https://mattyfresh.netlify.app/resume.pdf', // this should be https://yourname.com/resume.pdf once you've deployed
      link: 'https://matthewzou.pages.dev/resume.pdf', // this should be https://yourname.com/resume.pdf once you've deployed
      icon: 'fa fa-file',
      label: 'resume',
    },
    {
      link: 'https://www.instagram.com/silentvoice.photo/',
      icon: 'fa fa-instagram',
      label: 'art instagram',
    },
    {
      link: 'https://github.com/Mattyfreshy',
      icon: 'fa fa-github',
      label: 'github',
    },
    {
      link: 'https://www.linkedin.com/in/matthew-zou-abb42318a/',
      icon: 'fa fa-linkedin',
      label: 'linkedin',
    },
    // {
    //   link: 'https://twitter.com/Andy8647L',
    //   icon: 'fa fa-twitter',
    //   label: 'twitter',
    // },
  ],
  bio: "Hi! I'm Matthew Zou. I'm a Software Engineer at NAVAIR.",
  skills: {
    // you don't have to strictly follow the 'languages', 'frameworks', 'databases', 'cloudServices', and 'tools' categories. You can add your own if you'd like.
    // but the structure should be the same, an array of strings and the key should be one word, no spaces.
    languages: ['Assembly', 'C++', 'CMake', 'Java', 'Python', 'Ocaml', 'Racket'],
    tools: ['Git', 'Visual Studio Code', 'Visual Studio Code', 'Android Studio'],
    OS: ['Linux (WSL & Ubuntu)', 'Unix (RedHat)', 'Windows', 'MacOS'],
    other: ['OnShape', 'Autodesk Fusion', 'Blender', 'Procreate', 'Davinci Resolve Studio'],
  },
  hobbies: [
    // {
    //   label: 'Art/Illustrations',
    //   emoji: '🎨',
    // },
    // {
    //   label: 'Anime',
    //   emoji: '🎞',
    // },
    {
      label: 'Photography',
      emoji: '📷',
    },
    // {
    //   label: 'Video Games',
    //   emoji: '🎮',
    // },
    {
      label: 'Finance',
      emoji: '📈',
    },
    // Same as above, change the emojis to match / relate to your hobbies or interests.
    // You can also remove the emojis if you'd like, I just think they look cute :P
  ],
  portfolio: [
    // This is where your portfolio projects will be detailed
    //   for the null ones, the button will not show up
    {
      title: 'FTC Team 8221 Cubix - Programming, Mechanical Design, and Main Driver',
      live: null, //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
      photos: 'https://www.havish.dev/Documentation%20Highlights.png',
      source: 'https://github.com/HavishNetla/Sky-Stone', // this should be a link to the **repository** of the project, where the code is hosted.
      video: 'https://youtu.be/oj1q9ZR0LeI',
      image: cubix
    },
    {
      title: 'OnShape Team 8221 Cubix - Mechanical Design, CAD, 3D Rendering, and Video Editing',
      live: null,
      photos: null,
      source: null,
      video: 'https://youtu.be/NUS2Vo3vD5w',
      image: onshapeCubix
    },
    {
      title: 'Lotto/Odds — Scratch Off Analytics',
      live: 'https://scratch-odds.pages.dev/',
      photos: null,
      source: null,
      video: null,
      image: ScratchOff
    },
    {
      title: 'Pulse — U.S. Economic Dashboard',
      live: 'https://pulsedashboard.pages.dev/',
      photos: null,
      source: null,
      video: null,
      image: pulse
    },
    {
      title: 'Realpay - Stop Guessing Your Salary After Taxes',
      live: 'https://realpay-1kv.pages.dev/',
      photos: null,
      source: null,
      video: null,
      image: realpay
    },
    {
      title: 'Positioning Desk — COT Report Dashboard',
      live: 'https://cot-dashboard-53m.pages.dev/',
      photos: null,
      source: null,
      video: null,
      image: PositioningDesk
    },
    {
      title: 'Dividend Calculator - How Much Do You Need To Invest For Dividend Freedom',
      live: 'https://dividendcalculator.pages.dev/',
      photos: null,
      source: null,
      video: null,
      image: dividendcalculator
    },
    {
      title: 'Overbooked - Flight Overbooking Risk Formula-Based Scoring',
      live: 'https://overbooked.pages.dev/',
      photos: null,
      source: null,
      video: null,
      image: overbooked
    },
    {
      title: 'Site Speed Test - Test Your Connection Speed To Any Website',
      live: 'https://sitespeedtest.pages.dev/',
      photos: null,
      source: null,
      video: null,
      image: sitespeedtest
    },
    {
      title: 'Speech to Text - Live transcriptions for the hearing impaired',
      live: null,
      photos: null,
      source: 'https://github.com/Mattyfreshy/RTT',
      video: null,
      image: speechtotext
    },
    {
      title: 'FreshBot - Discord Bot that can play music and chat with users',
      live: null, 
      photos: null,
      source: 'https://github.com/Mattyfreshy/FreshBot', 
      video: null,
      image: freshbot
    },
    {
      title: 'Blackjack - BlackJack game with simulation and strategy testing features',
      live: null,
      photos: null,
      source: 'https://github.com/Mattyfreshy/BlackJack',
      video: null,
      image: BlackJack
    },
    
  ]
}
